import { BanIcon, ChartIcon, EyeOffIcon, OpinionsIcon } from '../Brand/Icon';
import React from "react";
import { Link } from 'react-router-dom';
import { Col, Row } from 'antd';
import UserReactionScope from '../UserReactionScope';
import { AnimatedLink } from '../Buttons/AnimatedLink';
import useStoryNavigation from '../../hooks/useStoryNavigation';
import { opinionLink } from '../../utils/opinionPath';
import './index.scss';
import { useTranslation } from 'react-i18next';

const StoryTitle = ({ storyId, title, finish, msg = '0', scope = 0, fill = true, reactionId = 0, opinion = null, activeSection = null, detailArea = 'all', onLeaveFeed, profileUsername, onSection, sectionsDisabled = false, entry = null, onMakePublic, privacyBusy = false }) => {
  const { t } = useTranslation();
  const hasOpinion = Number(scope) >= 1 && Number(scope) <= 7 && Number(reactionId) > 0;
  const hidden = hasOpinion && opinion?.is_hidden === true;
  const banned = hasOpinion && opinion?.is_banned === true;
  const canMakePublic = hidden && typeof onMakePublic === 'function';
  const Status = canMakePublic ? 'button' : 'span';
  const statusLabel = [hidden && t('settings:hiddenOpinion', { defaultValue: 'Hidden opinion' }),
    banned && t('settings:blockedOpinionContent', { defaultValue: 'Opinion contains blocked content' })].filter(Boolean).join('. ');
  const hasContent = typeof opinion?.has_content === 'boolean' ? opinion.has_content : String(msg) === '1';
  const { sectionLink, returnLink } = useStoryNavigation({ storyId, title, reactionId, activeSection, detailArea, onLeaveFeed, profileUsername, entry });
  const sectionProps = (section, route) => ({
    ...sectionLink(section, route),
    className: `storyTitle-section storyTitle-section--${section}${activeSection === section ? ' storyTitle-section--active' : ''}`,
    'aria-current': activeSection === section ? 'page' : undefined,
  });
  const sectionControl = (section, route, label, icon) => onSection
    ? <button type="button" className={`wiw-icon-button storyTitle-section storyTitle-section--${section}`}
        disabled={sectionsDisabled} aria-label={label} onClick={() => onSection(route)}>{icon}</button>
    : <AnimatedLink aria-label={label} {...sectionProps(section, route)}>{icon}</AnimatedLink>;

  return (
    <div className={`storyTitle${fill ? ' fill' : ''}${hasOpinion ? ' storyTitle--profile-opinion' : ''}`}>
      <Row className="storyTitle-row" wrap={false} align="middle" justify="center">
        <Col className="align-center storyTitle-statistics" flex="0 0 calc(100% / 7)">
          {!finish && sectionControl('statistics', 'statistic', t('story.statistics'), <ChartIcon className="nav-icon" />)}
        </Col>
        <Col className="align-center storyTitle-text-column" flex="auto">
          {activeSection
            ? <Link className="storyTitle-title storyTitle-return" {...returnLink}>{title}</Link>
            : hasOpinion && profileUsername
            ? <Link className="storyTitle-title storyTitle-return storyTitle-opinion-link"
                {...opinionLink({ reactionId, profileUsername, storyId, story: { id: storyId, title } })}>{title}</Link>
            : <div className="storyTitle-title">{title}</div>}
        </Col>
        <Col className="align-center storyTitle-actions" flex="0 0 calc(100% / 7)">
          {!finish && sectionControl('opinions', 'reactions', t('story.opinions'), <OpinionsIcon className="nav-icon" />)}
        </Col>
      </Row>
      {hasOpinion && <span className="storyTitle-opinion">
        <UserReactionScope scope={scope} msg_flg={hasContent ? '1' : '0'} reactionId={reactionId}
          storyId={storyId} story={{ id: storyId, title }} profileUsername={profileUsername} />
      </span>}
      {(hidden || banned) && <Status className={`storyTitle-status${canMakePublic ? ' storyTitle-status--action' : ''}${banned ? ' storyTitle-status--banned' : ''}${hidden && banned ? ' storyTitle-status--combined' : ''}`}
        {...(canMakePublic ? { type: 'button', disabled: privacyBusy, 'aria-busy': privacyBusy,
          onClick: event => { event.stopPropagation(); onMakePublic(); } } : { role: 'img' })}
        aria-label={canMakePublic ? `${statusLabel}. ${t('settings:makeOpinionPublic', { defaultValue: 'Make opinion public' })}` : statusLabel}
        title={canMakePublic ? t('settings:makeOpinionPublic', { defaultValue: 'Make opinion public' }) : statusLabel}>
        {hidden && <EyeOffIcon />}{banned && <BanIcon />}
      </Status>}
    </div>
  )
}

export default StoryTitle;
